import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M10.52 10.267 8.574 6.75a.338.338 0 0 0-.294-.167H4.969a.318.318 0 0 0-.282.167.29.29 0 0 0 0 .32l1.868 3.363-2.507 4.041a.29.29 0 0 0 0 .32.318.318 0 0 0 .281.166h3.313c.115 0 .204-.064.281-.166l2.596-4.22c.064-.077.064-.205.013-.307h-.013Zm8.913-6.101A.333.333 0 0 0 19.15 4h-3.504a.318.318 0 0 0-.281.166l-5.205 9.03a.29.29 0 0 0 0 .319l3.35 5.819a.333.333 0 0 0 .282.166h3.504c.115 0 .23-.064.281-.166a.29.29 0 0 0 0-.32l-3.261-5.653 5.116-8.875a.29.29 0 0 0 0-.32Z",
      fill: "#616a75"
    }, null, -1)
  ])))
}
export default { render };